<template>
  <Modal :closable="false" :shouldLimitHeight="false" :shouldNotHavePadding="true">
    <div class="content inquiry">
      <div class="content-upper">
        <div class="title">Confirm Phone Number</div>
        <div class="leader">Last step. Please confirm your phone number.</div>
        <form>
          <v-text-field v-model="phoneNumber" label="Phone Number" type="tel"></v-text-field>
          <v-select
            :items="phoneTypes"
            item-text="formattedName"
            item-value="vaule"
            label="Type"
            v-model="phoneType"
            return-object></v-select>
        </form>
      </div>
      <div class="content-lower">
        <div class="controls">
          <v-btn
            @click="
              $emit('update-phone', {
                phoneType: phoneType.value,
                phoneNumber,
              })
            "
            color="#ff9800"
            class="white--text font-weight-medium"
            plain>Submit</v-btn>
        </div>
      </div>
    </div>
  </Modal>
</template>
<script>
import Modal from '@/components/Shared/Modal.vue';

export const defaultSelectedPhoneType = { value: 'mobilePhone', formattedName: 'Mobile' };

export default {
  components: {
    Modal,
  },
  data() {
    return {
      phoneNumber: '',
      phoneType: { ...defaultSelectedPhoneType },
    };
  },
  computed: {
    phoneTypes() {
      return [
        { ...defaultSelectedPhoneType },
        { value: 'homePhone', formattedName: 'Home' },
        { value: 'workPhone', formattedName: 'Work' },
      ];
    },
  },
};
</script>
<style lang="scss">
.inquiry {
  padding: 20px 30px;

  form {
    display: grid;
    grid-template-columns: 5fr 3fr;
    gap: 1rem;
  }

  .content-lower {
    display: flex;
    justify-content: flex-end;
  }

  .controls {
    button {
      margin-bottom: 0;
    }
  }

  // Override some global styles that are set _application.scss partial
  .v-select .v-input__control .v-input__slot {
    border: inherit !important;
  }
  input,
  textarea {
    &,
    &:focus {
      border: inherit;
      outline: inherit;
      box-shadow: inherit;
      margin: 0;
    }
  }
}
</style>
